<div class="d-flex align-items-center justify-content-between w-full gap-5">
    <span>{{ message }}</span>
    <mat-spinner diameter="24" class="custom-spinner"></mat-spinner>
</div>
